"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _xstate = require("xstate");
var _guards = _interopRequireDefault(require("./guards"));
var _actions = require("./actions");
var _constants = require("../constants");
const {
  SUBMIT,
  REVERT
} = _constants.events;

/**
 * Returns properties for a step that may be used to configure it, e.g:
 * question, type of ui control, options
 * @param {Object} step
 */
const getStepConfig = step => {
  const {
    on,
    ...config
  } = step;
  return config;
};
const makeAskQuestionAction = id => [`${id}.askQuestion`, (0, _actions.askQuestionById)(id)];
const makeSetAnswerAction = id => [`${id}.setAnswer`, (0, _actions.setAnswerById)(id)];
const makeIsStepIdGuard = id => [`${id}.isStep`, (ctx, ev) => ev.id === id];
const getInitialSetup = _ref => {
  let {
    context
  } = _ref;
  return {
    services: {},
    actions: {
      revertToChatStep: _actions.revertToChatStep
    },
    guards: {
      ..._guards.default
    },
    machine: {
      context: {
        ...context,
        // required
        stepConfigById: {},
        chat: []
      },
      states: {},
      on: {
        [REVERT]: []
      }
    }
  };
};
const machineJSON = _ref2 => {
  let {
    config,
    context
  } = _ref2;
  const {
    machine,
    actions,
    guards,
    services
  } = getInitialSetup({
    context
  });
  (0, _forEach.default)(config).call(config, (step, index) => {
    const {
      id,
      on
    } = step;
    if (index === 0) {
      machine.initial = id;
    }

    // `stepConfigById` is used as a config lookup tool for a given state e.g:
    // "Which question text should be used on state FOO?"
    machine.context.stepConfigById[id] = getStepConfig(step);

    // Create actions for every step to allow reverting to an
    // arbitrary step no matter where we are in the flow
    const [isStepKey, isStepGuard] = makeIsStepIdGuard(id);
    guards[isStepKey] = isStepGuard;
    machine.on[REVERT].push({
      target: id,
      cond: isStepKey,
      actions: ['revertToChatStep']
    });

    // Add "ask question" on entry of this step
    const [askQuestionKey, askQuestionAction] = makeAskQuestionAction(id);
    actions[askQuestionKey] = askQuestionAction;
    machine.states[id] = {
      id,
      entry: [askQuestionKey]
    };

    // If a step has an `on` property, configure handlers
    if (on) {
      var _context;
      const [setAnswerKey, setAnswerAction] = makeSetAnswerAction(id);
      actions[setAnswerKey] = setAnswerAction;
      machine.states[id].on = {
        [SUBMIT]: (0, _map.default)(_context = on[SUBMIT]).call(_context, v => ({
          ...v,
          actions: [setAnswerKey]
        }))
      };
    }
  });
  return {
    machine,
    actions,
    guards,
    services
  };
};
const createMachine = function () {
  let {
    config,
    context
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!config) {
    return null;
  }
  const {
    machine,
    actions,
    guards,
    services
  } = machineJSON({
    config,
    context
  });
  return (0, _xstate.Machine)(machine).withConfig({
    actions,
    guards,
    services
  });
};
var _default = exports.default = createMachine;